import { create } from "zustand";

export enum FormState {
  SIGNUP = "signup",
  SIGNIN = "signin",
  VERIFICATION = "verification",
  VERIFIED = "verified",
}

type AuthData = {
  email?: string;
  password?: string;
};

type AuthStore = {
  formState: FormState;
  setFormState: (state: FormState) => void;
  data: AuthData;
  setData: (data: Partial<AuthData>) => void;
  reset: () => void;
};

export const useAuthStore = create<AuthStore>((set) => ({
  formState: FormState.SIGNUP,
  setFormState: (state) => set({ formState: state }),
  data: {},
  setData: (data) => set((state) => ({ data: { ...state.data, ...data } })),
  reset: () => set({ formState: FormState.SIGNUP, data: {} }),
}));
